import {FC} from 'react';
import {Box, Typography} from '@mui/material';
import {EmailOutlined, PhoneOutlined} from '@mui/icons-material';
import {useIntl} from 'react-intl';
import AMPModal from 'src/components/common/AMPModal';
import {FeedbackForm} from 'src/components/forms/FeedbackForm';
import {FeedbackTypeEnum} from 'src/types';
import {supportLinks} from 'src/utils/consts';
import {contactSupportSx} from './ContactSupportDialog.sx';

interface ContactSupportDialogProps {
    open: boolean;
    onClose: () => void;
    sessionId: string | null;
}

export const ContactSupportDialog: FC<ContactSupportDialogProps> = ({open, onClose, sessionId}) => {
    const intl = useIntl();

    const subject = intl.formatMessage(
        {id: 'aiAgentContactSupportEmailSubject'},
        {sessionId: sessionId ?? '—'}
    );
    const mailtoHref = `mailto:${supportLinks.helpEmail}?subject=${encodeURIComponent(subject)}`;
    const telHref = `tel:${supportLinks.companyPhoneNumber.replace(/\s/g, '')}`;

    return (
        <AMPModal
            handleClose={onClose}
            open={open}
            title={intl.formatMessage({id: 'aiAgentContactSupportTitle'})}
            type="xs"
            fullWidth
        >
            <Typography sx={contactSupportSx.subtitle}>
                {intl.formatMessage({id: 'aiAgentContactSupportSubtitle'})}
            </Typography>

            <Box sx={contactSupportSx.contactsRow}>
                <Box component="a" href={mailtoHref} sx={contactSupportSx.contactItem}>
                    <Box sx={contactSupportSx.contactIcon}>
                        <EmailOutlined/>
                    </Box>
                    <Box sx={contactSupportSx.contactContent}>
                        <Typography sx={contactSupportSx.contactLabel}>
                            {intl.formatMessage({id: 'aiAgentContactSupportEmailLabel'})}
                        </Typography>
                        <Typography sx={contactSupportSx.contactValue}>
                            {supportLinks.helpEmail}
                        </Typography>
                    </Box>
                </Box>

                <Box component="a" href={telHref} sx={contactSupportSx.contactItem}>
                    <Box sx={contactSupportSx.contactIcon}>
                        <PhoneOutlined/>
                    </Box>
                    <Box sx={contactSupportSx.contactContent}>
                        <Typography sx={contactSupportSx.contactLabel}>
                            {intl.formatMessage({id: 'aiAgentContactSupportPhoneLabel'})}
                        </Typography>
                        <Typography sx={contactSupportSx.contactValue}>
                            {supportLinks.companyPhoneNumber}
                        </Typography>
                    </Box>
                </Box>
            </Box>

            <Box sx={contactSupportSx.divider}>
                <Typography sx={contactSupportSx.dividerLabel}>
                    {intl.formatMessage({id: 'aiAgentContactSupportOrSendMessage'})}
                </Typography>
            </Box>

            <FeedbackForm
                type={FeedbackTypeEnum.HELP}
                handleClose={onClose}
            />
        </AMPModal>
    );
};